export default class {
    constructor(Component) {
        this.Component  = Component;
        this.buttons    = this.Component.read('buttons');
    }

    set container(content)  { return this.container.innerHTML = content }
    get container()         { return this.Component.container.querySelector('.js-teaser-buttons') }

    async renderButton() {
        const values    = await this.Component.getValues();
        const buttons   = this.buttons.split(',');
        if (buttons.length) {
            // We choose only first button
            const button = buttons[0];
            let marketing = false;
            // Create a price label
            if (button === 'price') {
                const offer = await values.Offer;
                values.priceFormatted = offer.priceFormatted;
                values.priceMarketingFormatted = offer.priceMarketingFormatted;
                if (offer.priceMarketing) marketing = offer.price != offer.priceMarketing;
            }
            return marketing ?
                App.Template.parse('teaser-button-marketing', values) :
                App.Template.parse('teaser-button-' + button, values);
        }
        return '';
    }

    render() {
        if (this.buttons) {
            this.renderButton().then(button => this.container = button);
        }
    }
}
